import { Component, computed, inject, input } from '@angular/core';
import { rxResourceFixed } from '@zayan-erp/shared';
import { DatePipe } from '@angular/common';
import { CardModule } from '@openng/optimus-ui/card';
import { DsmDealOptionsService } from '../../../services/dsm-deal-options.service';

@Component({
  selector: 'dsm-addendum-logs',
  standalone: true,
  imports: [DatePipe, CardModule],
  templateUrl: './dsm-addendum-logs.component.html'
})
export class DsmAddendumLogsComponent {
  readonly #dealOptionsService = inject(DsmDealOptionsService);

  readonly addendumId = input.required<string>();

  addendumLogsRxResource = rxResourceFixed({
    params: () => ({ optionId: this.addendumId() }),
    defaultValue: [],
    stream: ({ params }) => this.#dealOptionsService.getDealOptionLogs(params.optionId)
  });

  addendumLogs = computed(() => this.addendumLogsRxResource.value() ?? []);

  isDate(value: { key?: string; value?: string }): boolean {
    if (value.key?.toLowerCase().includes('date')) {
      if (!value.value || value.value === 'null' || value.value === '') return false;
      const date = new Date(String(value.value));
      return !isNaN(date.getTime()) && date.getFullYear() > 1900;
    }
    return false;
  }
}
